export const API_BASE =
  // "https://napkin-harmless-gruffly.ngrok-free.dev/api";
  "https://hrm.sportstech.team/api";

// "https://stelar-herbert-sinlike.ngrok-free.dev/api";
